export const OTP_RESET = 'OTP_RESET';
export const OTP_REQUEST_START = 'OTP_REQUEST_START';
export const OTP_REQUEST_FAILURE = 'OTP_REQUEST_FAILURE';
export const OTP_SUCCESS = 'OTP_REQUEST_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/otpActionTypes.js